import invariant from 'tiny-invariant'

import type { paths } from '@luxuryescapes/contract-svc-accommodation'

type ServerCalendarPrices = paths['/api/accommodation/properties/{propertyId}/calendar-prices']['get']
// Unfortunately, the following type isn't defined under `definitions`.
type ServerCalendarPricesResponseResult = ServerCalendarPrices['responses']['200']['content']['application/json']['result']

// NB: This mapper (as well as transitive mappers and related Customer Portal types) was last
// cross-checked against `contract-svc-accommodation` v22.0.1.
export default function mapPropertyCalendarPrices({
  // propertyId, // This is unused.
  los,
  currency,
  // occupancies, // This is unused.
  months,
}: ServerCalendarPricesResponseResult): { [isoDate: string]: App.Property.CalendarDay } {
  return Object.fromEntries(months.flatMap(({
    year,
    month,
    days,
  }) => {
    invariant(year >= 2026 && year <= 9999 && month >= 1 && month <= 12)
    const isoYearMonth = `${year}-${String(month).padStart(2, '0')}`

    return Object.entries(days).map(([day, calendarDayPrice]) => {
      // We don't care about specifics (like how February has 28 days).
      invariant(Number(day) >= 1 && Number(day) <= 31)
      const isoDate = `${isoYearMonth}-${day.padStart(2, '0')}`

      // Realistically, we won't have LuxPlus+ campaign prices without also having non-LuxPlus+
      // campaign prices. Note also that we're relying on accommodation service to explicitly return
      // days without pricing for the requested date range (instead of omitting them for brevity).
      if (!calendarDayPrice?.campaignPrice) {
        return [isoDate, {
          isoDate,
          type: 'unavailable',
          duration: los,
          currency,
        }]
      }

      return [isoDate, {
        isoDate,
        type: 'available',
        duration: los,
        currency,
        campaignDisplayPrice: calendarDayPrice.campaignPrice,
        campaignLuxPlusDisplayPrice: calendarDayPrice.campaignLuxPlusPrice,
      }]
    })
  }))
}
